import React from 'react';
import { Modal } from '@chakra-ui/core';
import { ModalBox } from '../common/Modal';
import { pxToRem } from '../../utils/dimensionConverter'

export const ModalInformation = ({
  isOpen,
  onClose,
  title,
  description,
  image,
  imageSize,
  size,
  renderActions,
  isClosable = false,
}) => {
  return (
    <Modal isOpen={isOpen} size={size} rounded={pxToRem(15)}>
      <ModalBox hideClose={isClosable} onButtonClose={() => onClose()}>
        <div className="modal-message not-found">
          <div className="modal-message__content">
            {image && <img className="modal-message__image" src={image} style={{ width: imageSize }} />}
            {title && <span className="modal-message__title text-center">{title}</span>}
            {description && <span className="modal-message__description text-center push--bottom">{description}</span>}
            {renderActions}
          </div>
        </div>
      </ModalBox>
    </Modal>
  )
};

export default ModalInformation;